import React from 'react'
import { Field, FormikProps, useFormikContext } from 'formik'
import { CheckboxInput } from '../../../../../../../components/inputs/CheckboxInput'
import RadioInput from '../../../../../../../components/inputs/RadioInput'
import { TextInput } from '../../../../../../../components/inputs/TextInput'
import { RichTextInput } from '../../../../../../../components/inputs/RichTextInput/RichTextInput'
import { B4_FORM_INITIAL_VALUES } from './constants'

interface Props {}

export const B4WaterFields: React.FC<Props> = (props) => {
  const formik = useFormikContext() as FormikProps<typeof B4_FORM_INITIAL_VALUES>

  return (
    <>
      <div className="sm:col-span-6">
        <Field
          name="b4.technicalInfrastructureConnection.waterSupply.enabled"
          component={CheckboxInput}
          label="Vodovod"
        />
        {formik.values.b4?.technicalInfrastructureConnection?.waterSupply?.enabled && (
          <>
            <div className="pl-7 mt-3">
              <span className="text-sm">Přípojka</span>
              <Field
                name="b4.technicalInfrastructureConnection.waterSupply.connectionCondition"
                component={RadioInput}
                options={[
                  { label: 'Stávající', value: 'existing' },
                  { label: 'Nová', value: 'new' },
                  { label: 'Rekonstruovaná', value: 'reconstructed' },
                  { label: 'Bez přípojky', value: 'none' },
                ]}
              />
            </div>
            {formik.values.b4?.technicalInfrastructureConnection?.waterSupply
              ?.connectionCondition !== 'none' && (
              <>
                <div className="pl-7 mt-3">
                  <span className="text-sm">Materiál a dimenze</span>
                  <Field
                    name="b4.technicalInfrastructureConnection.waterSupply.material"
                    component={TextInput}
                  />
                </div>
                <div className="pl-7 mt-3">
                  <span className="text-sm">Délka</span>
                  <Field
                    name="b4.technicalInfrastructureConnection.waterSupply.length"
                    component={TextInput}
                  />
                </div>
                <div className="pl-7 mt-3">
                  <span className="text-sm">Připojovací rozměr</span>
                  <Field
                    name="b4.technicalInfrastructureConnection.waterSupply.connectionDimension"
                    component={TextInput}
                  />
                </div>
                <div className="pl-7 mt-3">
                  <span className="text-sm">Výkonová kapacita</span>
                  <Field
                    name="b4.technicalInfrastructureConnection.waterSupply.performanceCapacity"
                    component={TextInput}
                  />
                </div>
              </>
            )}
            <div className="pl-7 mt-3">
              <Field
                name="b4.technicalInfrastructureConnection.waterSupply.description"
                component={RichTextInput}
                aiHint="Napojovací místa technické infrastruktury - Vodovod - Popis"
              />
            </div>
          </>
        )}
      </div>
      <div className="sm:col-span-6">
        <Field
          name="b4.technicalInfrastructureConnection.sewage.enabled"
          component={CheckboxInput}
          label="Splašková kanalizace"
        />
        {formik.values.b4?.technicalInfrastructureConnection?.sewage?.enabled && (
          <>
            <div className="pl-7 mt-3">
              <span className="text-sm">Přípojka</span>
              <Field
                name="b4.technicalInfrastructureConnection.sewage.connectionCondition"
                component={RadioInput}
                options={[
                  { label: 'Stávající', value: 'existing' },
                  { label: 'Nová', value: 'new' },
                  { label: 'Rekonstruovaná', value: 'reconstructed' },
                  { label: 'Bez přípojky', value: 'none' },
                ]}
              />
            </div>
            {formik.values.b4?.technicalInfrastructureConnection?.sewage?.connectionCondition !==
              'none' && (
              <>
                <div className="pl-7 mt-3">
                  <span className="text-sm">Materiál a dimenze</span>
                  <Field
                    name="b4.technicalInfrastructureConnection.sewage.material"
                    component={TextInput}
                  />
                </div>
                <div className="pl-7 mt-3">
                  <span className="text-sm">Délka</span>
                  <Field
                    name="b4.technicalInfrastructureConnection.sewage.length"
                    component={TextInput}
                  />
                </div>
                <div className="pl-7 mt-3">
                  <span className="text-sm">Připojovací rozměr</span>
                  <Field
                    name="b4.technicalInfrastructureConnection.sewage.connectionDimension"
                    component={TextInput}
                  />
                </div>
                <div className="pl-7 mt-3">
                  <span className="text-sm">Výkonová kapacita</span>
                  <Field
                    name="b4.technicalInfrastructureConnection.sewage.performanceCapacity"
                    component={TextInput}
                  />
                </div>
              </>
            )}
            <div className="pl-7 mt-3">
              <Field
                name="b4.technicalInfrastructureConnection.sewage.description"
                component={RichTextInput}
                aiHint="Napojovací místa technické infrastruktury - Splašková kanalizace - Popis"
              />
            </div>
          </>
        )}
      </div>
      <div className="sm:col-span-6">
        <Field
          name="b4.technicalInfrastructureConnection.drainage.enabled"
          component={CheckboxInput}
          label="Dešťová kanalizace"
        />
        {formik.values.b4?.technicalInfrastructureConnection?.drainage?.enabled && (
          <>
            <div className="pl-7 mt-3">
              <span className="text-sm">Přípojka</span>
              <Field
                name="b4.technicalInfrastructureConnection.drainage.connectionCondition"
                component={RadioInput}
                options={[
                  { label: 'Stávající', value: 'existing' },
                  { label: 'Nová', value: 'new' },
                  { label: 'Rekonstruovaná', value: 'reconstructed' },
                  { label: 'Bez přípojky', value: 'none' },
                ]}
              />
            </div>
            {formik.values.b4?.technicalInfrastructureConnection?.drainage?.connectionCondition !==
              'none' && (
              <>
                <div className="pl-7 mt-3">
                  <span className="text-sm">Materiál a dimenze</span>
                  <Field
                    name="b4.technicalInfrastructureConnection.drainage.material"
                    component={TextInput}
                  />
                </div>
                <div className="pl-7 mt-3">
                  <span className="text-sm">Délka</span>
                  <Field
                    name="b4.technicalInfrastructureConnection.drainage.length"
                    component={TextInput}
                  />
                </div>
                <div className="pl-7 mt-3">
                  <span className="text-sm">Připojovací rozměr</span>
                  <Field
                    name="b4.technicalInfrastructureConnection.drainage.connectionDimension"
                    component={TextInput}
                  />
                </div>
                <div className="pl-7 mt-3">
                  <span className="text-sm">Výkonová kapacita</span>
                  <Field
                    name="b4.technicalInfrastructureConnection.drainage.performanceCapacity"
                    component={TextInput}
                  />
                </div>
              </>
            )}
            <div className="pl-7 mt-3">
              <Field
                name="b4.technicalInfrastructureConnection.drainage.description"
                component={RichTextInput}
                aiHint="Napojovací místa technické infrastruktury - Dešťová kanalizace - Popis"
              />
            </div>
          </>
        )}
      </div>
    </>
  )
}
